'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _renderUtils = require('photography-client-lib/dist/src/utils/renderUtils');

var _renderUtils2 = _interopRequireDefault(_renderUtils);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _experimentsWrapper = require('photography-client-lib/dist/src/sdk/experimentsWrapper');

var _experimentsWrapper2 = _interopRequireDefault(_experimentsWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Utils = function (_RenderUtils) {
  (0, _inherits3.default)(Utils, _RenderUtils);

  function Utils() {
    (0, _classCallCheck3.default)(this, Utils);
    return (0, _possibleConstructorReturn3.default)(this, (Utils.__proto__ || (0, _getPrototypeOf2.default)(Utils)).apply(this, arguments));
  }

  (0, _createClass3.default)(Utils, [{
    key: 'isWixIframe',
    value: function isWixIframe() {
      return _windowWrapper2.default && !_windowWrapper2.default.isMock && _windowWrapper2.default.Wix && !_windowWrapper2.default.Wix.isMock && _windowWrapper2.default.top !== _windowWrapper2.default.self;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(element, to, duration, isHorizontal, callback) {

      if (this.isMobile()) {
        duration = 0; //do not animate scroll on mobile (looks jumpy and buggy)
      }

      var easeInOutQuad = function easeInOutQuad(currentTime, start, change, duration) {
        //t = current time
        //b = start value
        //c = change in value
        //d = duration
        if (duration === 0) {
          return change + start;
        }

        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime--;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      };

      var start = isHorizontal ? element.scrollLeft : element.scrollTop;
      var change = to - start;
      var currentTime = 0;
      var increment = 20;

      var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        } else {
          element.setAttribute('data-scrolling', '');
          if (typeof callback === 'function') {
            callback();
          }
        }

        if (isHorizontal) {
          element.scrollLeft = val;
        } else {
          element.scrollTop = val;
        }
      };

      element.setAttribute('data-scrolling', 'true');
      animateScroll();
    }

    // isVerbose() {
    //   return window.isMock || (!this.isTest() && ((this.safeLocalStorage() || {}).forceDevMode === 'true'));
    // }

  }, {
    key: 'positioningType',
    get: function get() {
      var pt = _experimentsWrapper2.default['specs.pro-gallery.itemsPositioning'] || 'relative';
      if (this.useRefactoredProGallery) {
        pt = 'absolute'; //on OOI / SSR use only absolute positioning
      }
      return pt;
    }
  }, {
    key: 'useRelativePositioning',
    get: function get() {
      return !(this.positioningType === 'absolute' || this.positioningType === 'transform');
    }
  }, {
    key: 'useRefactoredProGallery',
    get: function get() {
      return !!(_experimentsWrapper2.default['specs.pro-gallery.newGalleryContainer'] === 'true' || _experimentsWrapper2.default['specs.pro-gallery.useRefactoredProGallery'] === 'true') || _windowWrapper2.default && _windowWrapper2.default.isSSR || this.isOOI() || this.isDev() || this.isTest(); //on SSR use only refactor gallery
      // return (!!(experiments['specs.pro-gallery.newGalleryContainer'] === 'true' || experiments['specs.pro-gallery.useRefactoredProGallery'] === 'true')) || (window && window.isSSR) || this.isOOI() || this.isVerbose(); //on SSR use only refactor gallery
    }
  }]);
  return Utils;
}(_renderUtils2.default);

exports.default = new Utils();